module.exports = __webpack_public_path__ + "img/gaoxiao.cd29e86a.png";